<template>
    <div>
        <v-container max-width="2000" style="max-width:2000px !important">
            <v-card class="mx-auto my-5" max-width="2500">
                <!-- 
                <v-toolbar flat>
                    <v-toolbar-title>Diagrama de pacientes</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                -->
                <v-system-bar color="#1973a5" dark> Diagrama de pacientes </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <v-row style="padding: 1rem;margin: 0 !important;">
                    <v-col cols="3">
                        <v-text-field v-model="search" max-width="200" class="mx-3" label="Paciente"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            dense></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field v-model="searchClinica" max-width="200" class="mx-3" label="Clínica"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            dense></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Periodo" prepend-icon="mdi-calendar" readonly
                                    v-bind="attrs" v-on="on" dense></v-text-field>
                            </template>
                            <v-date-picker v-model="date" type="month" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field v-model="searchDistrito" max-width="200" class="mx-3" label="Distrito"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            dense></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field v-model="searchFrecuencia" max-width="200" class="mx-3" label="Frecuencia"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            dense></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-btn color="#1973a5" dark class="mb-2" @click="openReporte">
                            Ver reporte
                        </v-btn>
                    </v-col>
                </v-row>
                <div style="max-height: 70vh;overflow-y: scroll; width: 100% !important; max-width: 100rem !important;">
                    <v-data-table v-model="search" :items="filteredData">
                        <template v-slot:header="{ props }">
                            <thead>
                                <tr>
                                    <th rowspan="2" class="sticky-col left">Pacientes</th>
                                    <th colspan="31" style="text-align: center;">Mes</th>
                                    <th rowspan="2" class="sticky-col right2">Total asistió</th>
                                    <th rowspan="2" class="sticky-col right">Total faltó</th>
                                </tr>
                                <tr>
                                    <th v-for="day in 31" :key="day">Día {{ day }}</th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td class="sticky-col left" style="white-space: nowrap; font-size: .7rem;">{{
                                    item.paciente }}</td>
                                <td v-for="dia in 31" :key="`dia${dia}`" :class="itemClass(item[`dia_${dia}`])">
                                </td>
                                <td class="sticky-col right2" style="white-space: nowrap; font-size: .8rem;">{{
                                    item.total_asistio }}</td>
                                <td class="sticky-col right" style="white-space: nowrap; font-size: .8rem;">{{
                                    item.total_falto }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-container>

        <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
            <v-card color="primary" dark>
                <v-card-text>
                    Cargando Datos
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogReporte" v-if="dialogReporte" hide-overlay persistent width="1200" class="fondo-griss">
            <Reporte @closeReporte="closeReporte"></Reporte>
        </v-dialog>
    </div>
</template>
<style scoped>
.row {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin: 0px !important;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {

    height: 0px !important;
}

.bg-red {
    background: rgb(255 0 0 / 6%);
    color: #df0000 ! important;
    font-weight: 400;
}

.bg-green {
    background: rgb(30 155 16 / 10%);
    color: #129d28 ! important;
    font-weight: 400;
}

.bg-green {
    background: rgb(30 155 16 / 10%);
    color: #129d28 ! important;
    font-weight: 400;
}

.table-container {
    overflow-x: auto;
}

.sticky-col {
    position: sticky;
    background-color: white;
    z-index: 10;
}

.sticky-col.left {
    left: 0;
}

.sticky-col.right {
    right: 0;
}

.sticky-col.right2 {
    right: 53px;
}

.v-toolbar {
    background: linear-gradient(135deg, rgb(25, 115, 165), rgb(20, 145, 215), #0d67aa, #00304e);
    color: white !important;
}

.v-card-title {
    text-align: center;
}
</style>
<script>
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import axios from "axios";
import Reporte from "./index.vue"

export default {
    data: () => ({
        searchDistrito: null,
        search: null,
        searchClinica: null,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        tab: 0,
        dialogLoad: true,
        itemPacientes: [],
        searchDNI: null,
        searchPaciente: null,
        searchClinica: null,
        actionBoton: "LIBERAR CUPO",
        desserts: [],
        dialog: false,
        valid: true,
        itemsDatosPaciente: [],
        itemsTurno: [],
        itemsTipoSolcitud: [],
        nombrePaciente: "",
        estadoTab: "ATENDIDO",
        dialogAsignarCupo: false,
        itemPeriodo: null,
        itemMes: null,
        searchFrecuencia: null,
        dialogReporte: false
    }),
    methods: {
        closeReporte() {
            this.dialogReporte = false;
        },
        openReporte() {
            this.dialogReporte = true;
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        closeDialogAsignarCupo() {
            this.dialogAsignarCupo = false;
        },
        closeDialog() {
            this.dialog = false;
        },
        close() {
            this.$emit("closeDiagrama");
        },
        cambioTab() {
            if (this.tab == 0) {
                this.desserts = [];
                this.estadoTab = "PENDIENTE";
                this.liberados();
            } else if (this.tab == 1) {
                this.desserts = [];
                this.estadoTab = "ATENDIDO";
                this.ocupados();
            }
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.loadPacientes();
        },
        liberados() {
            this.dialogLoad = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API +
                            "/rep_cupos/?", { clinica_id: null, estado: false },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {

                            this.desserts = res.data;
                            this.dialogLoad = false;
                        })
                        .catch((res) => {
                            console.log("SSSSS", res.data);
                            this.dialogLoad = false;
                        });
                });
        },
        loadPacientes() {
            this.dialogLoad = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API +
                            "/reporte_asistencia_grafico/", { periodo: this.itemPeriodo, mes: this.itemMes },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {

                            this.itemPacientes = res.data;
                            this.dialogLoad = false;
                        })
                        .catch((res) => {
                            console.log("SSSSS", res.data);
                            this.dialogLoad = false;
                        });
                });
        },

    },
    computed: {
        filteredData() {
            if (!this.search && !this.searchClinica && !this.searchDistrito) {
                return this.itemPacientes;
            }
            let filtered = this.itemPacientes;
            if (this.search) {
                filtered = filtered.filter(item => item.paciente.toLowerCase().includes(this.search.toLowerCase()));
            }
            /* if (this.searchClinica) {
                filtered = filtered.filter(item => item.clinica.toLowerCase().includes(this.searchClinica.toLowerCase()));
            } */
            /* if (this.searchDistrito) {
               filtered = filtered.filter(item => item.clinica.toLowerCase().includes(this.searchDistrito.toLowerCase()));
           } */
            return filtered;
        },
        itemClass() {
            return (item) => {
                if (item == 1) {
                    return "bg-green"; // Aplica la clase "bg-primary" para el color #007bff
                } else if (item == 2) {
                    return "bg-red"; // No se aplica ninguna clase
                } else {
                    return "bg-plomo"; // No se aplica ninguna clase
                }
            };
        },
    },
    mounted() {
        if (!sessionStorage.getItem("keyValue")) {
            this.$router.push("/");
        }
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        this.url = sessionStorage.getItem("url");
        this.usuario = sessionStorage.getItem("usuario");
        this.urlCas = sessionStorage.getItem("urlCas");
        //INICIO DE CONSULTA
        this.liberados();
        this.loadPacientes();
    },
    components: {
        Reporte
    },
};
</script>